import React from 'react'
import { presence } from '../../utility/presence'
import { Fade } from 'react-awesome-reveal'

function Presence() {
    return (
        <section className="section-presence padding-tb-100">
            <img src="assets/img/effect/theme-7.png" alt="theme" className="theme-7" />
            <img src="assets/img/effect/theme-8.png" alt="theme" className="theme-8" />
            <img src="assets/img/effect/theme-9.png" alt="theme" className="theme-9" />
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <Fade triggerOnce duration={3000} direction='up' >
                            <div className="banner w-100 t-left">
                                <h2>Grow Your Presence With AI</h2>
                            </div>
                            <p>
                                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Enim
                                consequuntur, aut ratione voluptatibus assumenda obcaecati
                                quibusdam exercitationem ipsam amet consequatur, tempore numquam
                                esse tenetur recusandae libero illum, iure quidem reprehenderit.
                            </p>
                            <img src="assets/img/home/presence.png" alt="presence" className="zx-presence" />
                        </Fade>
                    </div>
                    <Fade triggerOnce duration={3000} direction='up' className="col-lg-6" >
                        <div className="zx-brands">
                            {
                                presence.map((data, index) => (
                                    <div key={index} className="zx-approach">
                                        <div className="zx-box result-placeholder">
                                            {data.persantine}
                                            <span>{data.number}</span>
                                        </div>
                                        <div className="zx-tex">
                                            <h4>{data.title}</h4>
                                            <p>{data.discription}</p>
                                        </div>
                                    </div>
                                ))
                            }

                        </div>
                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Presence
